import React from 'react';
import { useEditor } from '../context';
import { EDITOR_TYPES } from '../robot.types';
import { KEYBOARD_TYPES } from '../../keyboard/types';
import UseKeyboard from '../../keyboard/use-keyboard';
import { PreloadCode } from '../__code-container/robot__code-container';
import RobotControls from '../__controls';

export const RobotKeyboard = () => {
    const editor = useEditor();
    const isCodeLightV2 = editor.editor === EDITOR_TYPES.CODE_LIGHT_V2;

    const keyboardType = isCodeLightV2 ? KEYBOARD_TYPES.PROBLEM_BAR_ROVER : KEYBOARD_TYPES.PROBLEM_BAR;
    const controlsVariant = isCodeLightV2 ? 'code_light_v2' : 'default';

    return (
        <UseKeyboard keyboardType={keyboardType} show={true}>
            <PreloadCode />
            <RobotControls variant={controlsVariant} />
        </UseKeyboard>
    );
};
